// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"84b4358d","184":"7ecbc505","492":"a1964c2e","642":"d908a6a8","862":"73571ef2","975":"13d9fef6"}[chunkId] + ".chunk.js";
};